// Общие данные главной: библиотека треков-примеров и площадки проекта.
//
// Главная «/» рисуется китом лендингов по конфигу (см. homeContent.ts) — тексты
// секций живут там. Здесь остаётся то, что нужно ещё кому-то: TRACKS играют все
// лендинги (kit/Examples.tsx), SOCIALS — секция «Где нас найти» на главной.
// ── Хостинг ассетов ───────────────────────────────────────────
// Аудио/картинки лендинга НЕ лежат в репозитории — они на S3/MinIO. Единая точка
// подстановки: базовый URL. Реальный адрес задаётся через env
// `REACT_APP_LANDING_ASSETS_BASE` (dotenv-webpack), иначе — плейсхолдер ниже.
// Ассеты лендинга лежат ПЛОСКО в `landing/` (имена 1:1 с файлами дизайн-макета:
// у каждого трека парные `<name>.mp3` + `<name>.(png|jpg)`).
export const LANDING_ASSETS_BASE = (process.env.REACT_APP_LANDING_ASSETS_BASE ||
    "https://storage.yandexcloud.net/virtuoz-songs/landing").replace(/\/+$/, "");
/** Строит полный URL ассета лендинга по ключу (относительно LANDING_ASSETS_BASE). */
export const asset = (file) => `${LANDING_ASSETS_BASE}/${file}`;
// ── Библиотека примеров (общая для главной и всех лендингов) ───
export const TRACKS = [
    { title: "Ночной перегон", genre: "Techno · 132", dur: "3:48", song: "nochnoy-peregon.mp3", cover: "nochnoy-peregon.jpg" },
    { title: "Сотка на МКАДе", genre: "Phonk · 148", dur: "2:31", song: "sotka-na-mkade.mp3", cover: "sotka-na-mkade.jpg" },
    { title: "Помехи", genre: "Lo-fi · 84", dur: "2:56", song: "pomehi.mp3", cover: "pomehi.jpg" },
    { title: "Гараж", genre: "Drill · 142", dur: "3:12", song: "garazh.mp3", cover: "garazh.png" },
    { title: "Синтетика", genre: "Hyperpop · 160", dur: "2:18", song: "sintetika.mp3", cover: "sintetika.png" },
    { title: "Тёплый винил", genre: "Инди-поп · 96", dur: "3:34", song: "tyoplyy-vinil.mp3", cover: "tyoplyy-vinil.png" },
    { title: "Волна", genre: "Dnb · 174", dur: "4:02", song: "volna.mp3", cover: "volna.png" },
    { title: "Первый куплет", genre: "Русский рэп · 88", dur: "3:07", song: "pervyy-kuplet.mp3", cover: "pervyy-kuplet.png" },
];
// ── Площадки проекта («Где нас найти») ─────────────────────────
// Ссылки голые (без `?start=`), поэтому через `/click` они уходят без `utm` —
// `user.utm` остаётся пустым, как и раньше. VK намеренно БЕЗ `clickTarget`:
// на бэке `vk_bot` указывает на другую форму ссылки (`vk.com/im?sel=…`) и
// затирает `ref=vk`, а VK читает `ref` только у первого сообщения нового
// диалога — риск сломать текущую метку выше выигрыша. Поддержка тоже
// статическая: там свой бот и свой payload.
export const SOCIALS = [
    { kind: "telegram", title: "Бот в Телеграме", text: "@VirtuosRobot", url: "https://t.me/VirtuosRobot", clickTarget: "telegram_bot" },
    { kind: "max", title: "Бот в MAX", text: "max.ru", url: "https://max.ru/id550367227555_bot", clickTarget: "max_bot" },
    { kind: "vk", title: "Бот во ВКонтакте", text: "vk.com", url: "https://vk.com/write-239415665?ref=vk" },
    { kind: "support", title: "Написать в поддержку", text: "@Virtuos_help", url: "https://t.me/Virtuos_help" },
];
